import { createContext } from "react";

const CatViasContext = createContext();

export default CatViasContext;
